import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_HTTP_URL || '/portal-seguranca/';
export const REACT_URL_CONFIG = process.env.REACT_APP_URL_CONFIG || 'https://app-originar-security-portal-tst.azurewebsites.net/'
export const ID_MODULO_SEGURANCA = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
export const API_NOTIFICACOES_URL = process.env.REACT_APP_API_NOTIFICACOES_URL || 'https://app-originar-monitoring-tst.azurewebsites.net/api';
export const REACT_APP_AZURE_URL = process.env.REACT_APP_AZURE_AD_URL
export const REACT_APP_AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID
export const REACT_APP_AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID

export default axios.create({
    responseType: "json",
    baseURL: REACT_URL_CONFIG
});


